var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2H15C15.6 2 16 1.6 16 1C16 0.4 15.6 0 15 0H1C0.4 0 0 0.4 0 1C0 1.6 0.4 2 1 2ZM1 8H15C15.6 8 16 7.6 16 7C16 6.4 15.6 6 15 6H1C0.4 6 0 6.4 0 7C0 7.6 0.4 8 1 8ZM1 14H15C15.6 14 16 13.6 16 13C16 12.4 15.6 12 15 12H1C0.4 12 0 12.4 0 13C0 13.6 0.4 14 1 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.38a1495a87f61a0d8e149e8de4a1a2fa.svg";
export { ForwardRef as ReactComponent };